import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EditUserResponse } from 'src/app/model/response/user/user';
import { environment } from 'src/environments/environment';
import { CreateUser, UpdateUser, User } from '../login/login';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private url = `${environment.apiUrl}/users`;
  constructor(private http: HttpClient) { }

  /**
   * return all users lazy loaded
   */
  getUsersLazy(offset: number, max: number): Observable<User[]> {
    return this.http.get<User[]>(`${this.url}/get/lazy/${offset}/${max}`);
  }

  /**
   * Get all userData
   */
  getAllUsers(): Observable<User[]> {
    return this.http.get<User[]>(`${this.url}`);
  }

  /**
   * Get user data rows count
   */
  getRows(): Observable<number> {
    return this.http.get<number>(`${this.url}/rows`);
  }

  /**
   * Get Userdata by id
   */
  getUserById(id: string): Observable<User> {
    return this.http.get<User>(`${this.url}/${id}`);
  }

  /**
  * Get Userdata by username
  */
  getCurrentUserProfile(): Observable<User> {
    return this.http.get<User>(`${this.url}/me`);
  }

  /**
   * check id the user is locked
   */
  checkuserLock(id: number): Observable<any> {
    return this.http.get<any>(`${this.url}/check/lock/${id}`);
  }

  /**
   * set lock on user
   */
  setLockUser(id: number, username?: string): Observable<any> {

    let url = `${this.url}/set/lock/${id}`;

    if (username !== null) {
      url = url + `?username=${username}`;
    }

    return this.http.put<any>(url, null);
  }

  /**
   * check username exist
   */
  usernameExist(username: string): Observable<boolean> {
    return this.http.get<boolean>(`${this.url}/exist/username/${username}`);
  }


  /**
   * check email exist
   */
  emailExist(email: string): Observable<boolean> {
    return this.http.get<boolean>(`${this.url}/exist/mail/${email}`);
  }

  /**
   * change user authorization
   */
  editAuthorization(id: number, state: boolean): Observable<any> {
    return this.http.put(`${this.url}/edit/access/${id}/${state}`, null);
  }

  /**
   * edit 1 user
   */
  editUser(id:string, user: UpdateUser): Observable<User> {
    return this.http.put<User>(`${this.url}/${id}`, user);
  }



  /**
   * Create new user from backend
   */
  addNewUser(user: CreateUser): Observable<User> {
    return this.http.post<User>(`${this.url}`, user);
  }

  /**
   * Delete user by id
   */
  deleteUser(userId: number): Observable<any> {
    return this.http.delete<any>(`${this.url}/${userId}`);
  }




}
